import { FileService } from 'app/_services/file.service';
import { BalancingGroupAssignmentResource } from 'app/_resources/balancing-group.resource';
import { NetworkPointResource } from 'app/_resources/network-point.resource';
import { PortfolioCodeAssignmentResource } from 'app/_resources/portfolio-code.resource';
import { ReverseAuctionResource } from 'app/_resources/reverse-auction.resource';
import { SecondaryResource } from 'app/_resources/secondary.resource';
import { ProductResource } from 'app/_resources/product.resource';
import * as angular from 'angular';
import { XmlUploader } from '../custom';

(function () {
    'use strict';

    /**
     * @ngdoc controller
     * @name XmlUploadCtrl
     * @memberof app
     *
     * @description
     * This is the controller for the uploads landing page.
     *
     * @author frbomke.btc
     */
    angular.module('app').controller('XmlUploadsCtrl', XmlUploadsCtrl);

    function XmlUploadsCtrl(
        $routeParams,
        $scope,
        uploadsService,
        $location,
        INCLUDE,
        fileService: FileService,
        balancingGroupAssignmentResource: BalancingGroupAssignmentResource,
        NetworkPoint: NetworkPointResource,
        portfolioCodeAssignmentResource: PortfolioCodeAssignmentResource,
        reverseAuctionResource: ReverseAuctionResource,
        secondaryResource: SecondaryResource,
        productResource: ProductResource
    ) {
        var vm = this;
        vm.reset = reset;
        vm.goBack = goBack;
        vm.downloadSOAP = downloadSOAP;
        vm.INCLUDE = INCLUDE;
        vm.ui = {
            title: 'New XML upload',
            isLoading: false,
            success: false,
            successMessage: 'XML upload successfully finished.',
            error: false,
            errorMessage: null,
            errorDetailsShow: false
        };

        const contentType = $routeParams.contentType
            ? uploadsService.UPLOAD_CONTENT[$routeParams.contentType]
            : uploadsService.getUploadContentType();

        vm.data = {
            contentType,
            xmlContent: ''
        };
        vm.fileUpload = {};

        vm.toggleDetails = toggleDetails;

        if (vm.data.contentType == null) {
            $location.path('/uploads');
        }

        $scope.fileUpload = function (event, dragfiles) {
            vm.ui.errorMessage = '';
            vm.ui.errorDetails = [];
            let files;
            if (!dragfiles) {
                files = event.target.files;
            } else {
                files = dragfiles;
            }

            if (files.length > 0) {
                var file = files[0];
                if (file.type == 'text/xml') {
                    var reader = new FileReader();
                    reader.onload = fileIsLoaded;
                    reader.readAsText(file);
                } else {
                    vm.ui.error = true;
                    vm.ui.errorMessage = 'Please provide a valid XML file.';
                }
            }
        };

        function fileIsLoaded(e) {
            vm.ui.error = false;
            vm.data.xmlContent = e.target.result;
            $('#fileupload').val('');
        }

        var droparea = $('#droparea');

        droparea.on('dragover', function (e) {
            e.preventDefault();
            e.stopPropagation();
            droparea.addClass('dropready');
        });
        droparea.on('dragleave', function (e) {
            e.preventDefault();
            e.stopPropagation();
            droparea.removeClass('dropready');
        });
        droparea.on('dragenter', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });

        droparea.on('drop', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if ((e.originalEvent as DragEvent).dataTransfer) {
                if (
                    (e.originalEvent as DragEvent).dataTransfer.files.length > 0
                ) {
                    $scope.fileUpload(
                        e,
                        (e.originalEvent as DragEvent).dataTransfer.files
                    );
                }
            }
            droparea.removeClass('dropready');
            return false;
        });

        function reset() {
            vm.data.xmlContent = '';
            vm.ui.success = false;
            vm.ui.error = false;
            vm.form.$setPristine();
        }

        function toggleDetails() {
            if (vm.ui.errorDetailsShow) {
                vm.ui.errorDetailsShow = false;
            } else {
                vm.ui.errorDetailsShow = true;
            }
        }

        function goBack() {
            $location.path('/uploads');
        }

        function sendXml() {
            vm.ui.isLoading = true;
            vm.ui.success = false;
            vm.ui.error = false;
            vm.ui.errorMessage = null;

            let formData = new FormData();
            formData.append('file', vm.data.xmlContent);

            let xmlUploader: XmlUploader;
            if (
                vm.data.contentType ===
                uploadsService.UPLOAD_CONTENT.BALANCING_GROUP
            ) {
                xmlUploader = balancingGroupAssignmentResource;
            } else if (
                vm.data.contentType ===
                uploadsService.UPLOAD_CONTENT.PORTFOLIO_CODE
            ) {
                xmlUploader = portfolioCodeAssignmentResource;
            } else if (
                vm.data.contentType ===
                uploadsService.UPLOAD_CONTENT.NETWORK_POINT
            ) {
                xmlUploader = NetworkPoint;
            } else if (
                vm.data.contentType ===
                uploadsService.UPLOAD_CONTENT.REVERSE_AUCTION
            ) {
                xmlUploader = reverseAuctionResource;
            } else if (
                vm.data.contentType ===
                uploadsService.UPLOAD_CONTENT.TRADE_PROPOSAL_STATUS
            ) {
                xmlUploader = secondaryResource;
            } else {
                xmlUploader = productResource;
            }

            return xmlUploader.uploadAsXML(
                {},
                formData,
                function (response) {
                    vm.ui.success = true;
                    vm.ui.isLoading = false;
                    vm.ui.successmessage = response.responseXml;
                    vm.ui.successMessageId = $(response.responseXml)
                        .find('pkp-core\\:messageIdentification')
                        .text();
                },
                function (error) {
                    vm.ui.error = true;
                    vm.ui.errorMessage = 'The xml upload failed!';
                    vm.ui.errorDetails = [];
                    vm.ui.errorDetails.push(error.data.message);
                    vm.ui.isLoading = false;
                }
            ).$promise;
        }

        function mappedData() {
            var param = {
                content: vm.data.xmlContent,
                fallbackEndpointType: vm.data.contentType.fallbackEndpointType
            };
            return param;
        }

        vm.submit = submit;
        function submit(form) {
            if (!form.$valid) {
                return false;
            }
            sendXml();
        }

        function downloadSOAP(): boolean {
            return fileService.triggerFileDownload(
                vm.ui.successmessage,
                vm.data.contentType.name +
                    '_' +
                    vm.ui.successMessageId +
                    '.xml',
                'text/xml'
            );
        }
    }
})();
